<template>
  <div class="page-component-wrapper">
    <div class="page-side companies-page">
      <div class="page-side__header">
        <h1 class="page-title">{{L10n('companies')}}</h1>
      </div>
      <div class="page-side__content white-background">
        <company-select-panel
          :companyID="companyID"
          :activeTab="activeTab"
          :tabs="permissionTabList"
          :isAvailableToEdit="isAvailableToEdit"
          @update:companyID="handleChangeCompany"
          @updateCompanyName="changeCompanyName"
          @addNew="addNew"
          @changeTab="handleChangeTab($event)"
        />
        <div class="tabs__list d-none d-md-block">
          <div
            class="tabs__item"
            v-for="(tab, tabIndex) in permissionTabList"
            :key="tabIndex"
            :class="{'is-active': tab.name === currentTab.name, 'is-disabled': disabledTabs}"
            @click="handleChangeTab(tab.name)"
          >
            <span :title="tab.label">{{tab.label}}</span>
          </div>
        </div>
        <div class="tabs__content">
          <component
            :is="currentComponentName"
            :isAvailableToEdit="isAvailableToEdit"
            :companyID="companyID"
            :companyName="companyName"
            :name="currentTab.name"
          />
        </div>
      </div>
    </div>
    <modal-new :config="{id: pageID}" @creatSuccess="handleCreateSuccess"/>
  </div>
</template>

<script>
export default {
  name: 'Companies',
  components: {
    'company-select-panel': () => import(/* webpackChunkName: 'Companies' */ './CompanySelectPanel'),
    'modal-new': () => import(/* webpackChunkName: 'Companies' */ './ModalNew'),
    'tab-contacts': () => import(/* webpackChunkName: 'Companies' */ './Tabs/Contacts/Index'),
    'tab-details': () => import(/* webpackChunkName: 'Companies' */ './Tabs/Details/Index'),
    'tab-market': () => import(/* webpackChunkName: 'Companies' */ './Tabs/Market/Index'),
    'tab-forwarders': () => import(/* webpackChunkName: 'Companies' */ './Tabs/Forwarders/Index'),
    'tab-fleets': () => import(/* webpackChunkName: 'Companies' */ './Tabs/Fleets/Index'),
    'tab-iso': () => import(/* webpackChunkName: 'Companies' */ './Tabs/ISO/Index'),
    'tab-non-conformity-analyzes': () => import(/* webpackChunkName: 'Companies' */ './Tabs/NonConformityAnalyzes/Index'),
    'tab-credit-terms': () => import(/* webpackChunkName: 'Companies' */ './Tabs/CreditTerms/Index'),
    'tab-history': () => import(/* webpackChunkName: 'Companies' */ './Tabs/History/Index'),
    'tab-quote': () => import(/* webpackChunkName: 'Companies' */ './Tabs/Quote/Index'),
    'tab-default': () => import(/* webpackChunkName: 'Companies' */ './Tabs/Default/Index')
  },
  data () {
    return {
      activeTab: 'details',
      isTabEditor: false,
      companyID: null,
      companyName: null,
      pageID: 'Companies',
      companyTabs: [
        {
          name: 'details',
          label: this.L10n('details'),
          component: 'tab-details',
          permissionView: null
        },
        {
          name: 'contacts',
          label: this.L10n('contacts'),
          component: 'tab-contacts',
          permissionView: null
        },
        {
          name: 'market',
          label: this.L10n('atr-market-business-data'),
          component: 'tab-market',
          permissionView: 'isAllowToViewShippers'
        },
        {
          name: 'forwarders',
          label: this.L10n('forwarders'),
          component: 'tab-forwarders',
          permissionView: 'isAllowToViewShippers'
        },
        {
          name: 'fleets',
          label: this.L10n('fleets'),
          component: 'tab-fleets',
          permissionView: 'isAllowToViewShippers'
        },
        {
          name: 'iso',
          label: this.L10n('iso'),
          component: 'tab-iso',
          permissionView: null
        },
        {
          name: 'non-conformity-analyzes',
          label: this.L10n('non-conformity-analyzes'),
          component: 'tab-non-conformity-analyzes',
          permissionView: 'isAllowToViewNonConformityAnalyzes'
        },
        {
          name: 'credit',
          label: this.L10n('credit-terms'),
          component: 'tab-credit-terms',
          permissionView: 'isAllowToViewShippers'
        },
        {
          name: 'history',
          label: this.L10n('business-history'),
          component: 'tab-history',
          permissionView: 'isAllowToViewShippers'
        },
        {
          name: 'quote',
          label: this.L10n('quote-listing'),
          component: 'tab-quote',
          permissionView: 'isAllowToViewShippers'
        }
      ]
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.get('permissions')
    },
    isAvailableToEdit () {
      return this.permission(this.permissions, 'isAllowToEditCompanies')
    },
    disabledTabs () {
      return !this.companyID
    },
    currentTab () {
      let component = this.permissionTabList.find(tab => tab.name === this.activeTab)
      let defaultComponent = { name: 'default', component: 'tab-default' }
      return this.disabledTabs || !component
        ? defaultComponent
        : component
    },
    permissionTabList () {
      return this.companyTabs.filter(({ permissionView }) => {
        return this.permission(this.permissions, permissionView)
      })
    },
    currentComponentName () {
      return this.currentTab.component
    }
  },
  methods: {
    handleChangeCompany (companyID) {
      this.companyID = companyID
      this.setQuery({ key: 'companyID', value: this.companyID })
    },
    changeCompanyName (name) {
      this.companyName = name
    },
    handleChangeTab (tabName) {
      if (!this.disabledTabs) {
        this.activeTab = tabName
      }
      this.setQuery({ key: 'tab', value: this.activeTab })
    },
    setQuery (queryParam) {
      let { key, value } = queryParam
      let isDelete = !(value || typeof (value) === 'number')
      let query = Object.assign({}, this.$route.query)
      if (isDelete) {
        delete query[key]
      } else {
        query = Object.assign(query, { [key]: value })
      }
      this.$router.replace({ query })
    },
    addNew () {
      this.setQuery({ key: this.pageID, value: 'new' })
    },
    handleCreateSuccess (Data) {
      this.handleChangeCompany(Data.id)
    },
    checkQueryParams () {
      this.handleChangeCompany(this.getQueryParam('companyID', Number))
      this.handleChangeTab(this.getQueryParam('tab', String, 'details'))
    }
  },
  created () {
    this.checkQueryParams()
  }
}
</script>

<style lang="stylus">
  .page-side{
    height 100%
    display flex
    flex-direction column
    .tab-content{
      height 100%
    }
  }
  .page-side__content{
    flex-grow 1
    display grid
    grid-template-areas:
    "empty panel"\
    "tabs-list tabs-content"
    grid-template-rows auto 1fr
    grid-template-columns 20% 1fr
    grid-gap 0px
    padding 0
    & > * {
      min-width 0
    }
  }
  .page-side__header{
    display flex
    justify-content space-between
  }
  .company-select-panel{
    grid-area panel
    border-left 1px solid #eeeeef
  }
  .page-side__tabs{
    border-top 1px solid #eeeeef
    //grid-area tabs
  }
  .tabs__list{
    grid-area tabs-list
    border-top 1px solid #eeeeef
  }
  .tabs__item{
    cursor pointer
    padding: 0 20px
    height: 61px
    line-height: 61px
    display block
    list-style none
    font-size 14px
    position relative
    border-bottom 1px solid #eeeeef
    color #65646c
    text-transform capitalize
    font-weight bold
    text-overflow ellipsis
    white-space nowrap
    overflow hidden
    &.is-active{
      color #06aaea
      &:after{
        transform: scale(1)
      }
    }
    &.is-disabled{
      cursor auto
      color #b0afb5
    }
    &:after{
      content ''
      display block
      position absolute
      width 100%
      left 0
      bottom 0
      background: #06aaea
      height: 2px
      transform: scale(0, 1)
      transition: transform 0.3s ease
    }
  }
  .tabs__content{
    grid-area tabs-content
    border-top 1px solid #eeeeef
    border-left 1px solid #eeeeef
  }
  // Grids
  .content{
    .tabs__content{
      .grid-side {
        .grid-head {
          margin 0
          padding 1rem 3rem 0 3rem
          h1 {
            padding 0
          }
          .tool-controls {
            padding 0
          }
        }
      }
    }
  }
  .tab-view-grid{
    .grid-side {
      .grid-wrapper{
        border none
        margin 0
        .grid-table table > tbody > tr td.row-controls ul{
          flex-wrap nowrap !important
        }
      }
    }
  }
  // List
  .tab-view-list{
    position relative
    overflow hidden
    display flex
    flex-direction column
    padding 2rem
    .form-item__is-last{
        border none
    }
    .form-item__controls-wrap {
      .default-form-controls{
        padding .5rem 0 0
      }
    }
  }
  .tab-view-list__wrap{
    flex 1
    position relative
    margin 0 1rem
  }
  .tab-view-list__scroll-wrap{
    position absolute
    top 0
    left 0
    right 0
    bottom 0
    overflow auto
  }
  .tab-header{
    display flex
    justify-content space-between
    align-items center
    padding 1rem 3rem 1rem 3rem
    border-bottom 1px solid #eeeeef
    h1{
      &.page-title{
        margin 0
      }
    }
  }
  .tab-header__controls{
    & > div {
      padding 1rem 0 1rem 2rem
    }
  }
  @media only screen and (max-width: 767px) {
    .page-side__content{
      flex-grow 1
      display grid
      grid-template-areas:
        "panel"\
        "tabs-list"\
        "tabs-content"
      grid-template-rows auto auto 1fr
      grid-template-columns 1fr
      grid-gap 0px
      padding 0
    }
    .tabs__list{
      display: flex
      width: 100%;
      overflow hidden;
    }
  }
  @media only screen and (max-width: 576px) {
    .content{
      .tabs__content{
        .grid-side {
          .grid-head {
            margin 0
            padding 1rem
            h1 {
              padding 0
            }
            .tool-controls {
              padding 0
            }
          }
        }
      }
    }
    .tab-header{
      padding 1rem
    }
  }
</style>
